import componentFactory from '../shared/componentFactory';
import { Footer } from '@spotify-internal/masthead';

import '@spotify-internal/masthead/index.css';

export default componentFactory(Footer, 'Footer');
